import { useEffect, useState } from 'react';
import RefundInfoView from '@/dashboard/components/Products/policyCard/components/refundInfo/index';
import { usePolicyCardDetailInfo } from '@/dashboard/hooks/policy/card/usePolicyCardDetailInfo';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { REQUEST_SUCCESS_CODE, apiGetPolicyUnconfirmedPaymentAdjustmentInfo, policyHaveUnconfirmedPaymentInfo } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import { isArray } from 'lodash';
import CurrentPolicyProductCoverageAndPriceInfoView from './components/coverAndPrice';
import RenewPolicyProductInfoView from './renew';

interface PolicyProductInfoViewProps {
  policy: PolicyModel;
}
const PolicyProductInfoView = (props: PolicyProductInfoViewProps) => {
  const { policy } = props;
  const {
    updateAllCoverageAndPriceInfoList,
    currentCoverList,
    currentPriceList,
    currentPaymentScheduleList,
    renewCoverList,
    renewPriceList,
    renewPaymentScheduleList,
    renewDraftCoverList,
    renewDraftPriceList,
    renewDraftPaymentScheduleList,
  } = usePolicyCardDetailInfo();
  const [unconfirmedPaymentInfoList, setUnconfirmedPaymentInfoList] = useState([]);

  const requestUnconfirmPaymentInfo = async () => {
    const [res] = await apiGetPolicyUnconfirmedPaymentAdjustmentInfo({ policyId: policy?.id, hideErrToast: true });

    if (res?.code === REQUEST_SUCCESS_CODE && isArray(res.data?.list)) {
      setUnconfirmedPaymentInfoList(res.data.list);
    }
  };

  /**
   * effects
   */
  useEffect(() => {
    if (policy) {
      updateAllCoverageAndPriceInfoList(policy);
      if (policyHaveUnconfirmedPaymentInfo(policy)) {
        requestUnconfirmPaymentInfo();
      }
    }
  }, [policy]);

  if (currentCoverList.length === 0) {
    return null;
  }

  return (
    <Box className="flex flex-col">
      <CurrentPolicyProductCoverageAndPriceInfoView
        coverList={currentCoverList}
        priceList={currentPriceList}
        paymentScheduleList={currentPaymentScheduleList}
        unconfirmedPaymentInfoList={unconfirmedPaymentInfoList}
      />
      {renewCoverList.length > 0 && (
        <RenewPolicyProductInfoView
          className="mt-3"
          coverList={renewCoverList}
          priceList={renewPriceList}
          renewQuotePayload={policy.renewalQuotePayload}
          dataSourceType="confirmed"
          paymentScheduleList={renewPaymentScheduleList}
        />
      )}
      {renewDraftCoverList.length > 0 && (
        <RenewPolicyProductInfoView
          className="mt-3"
          coverList={renewDraftCoverList}
          priceList={renewDraftPriceList}
          renewQuotePayload={policy.renewalDraftQuotePayload}
          dataSourceType="draft"
          paymentScheduleList={renewDraftPaymentScheduleList}
          policy={policy}
        />
      )}
      <RefundInfoView policy={policy} />
    </Box>
  );
};

export default PolicyProductInfoView;
